<ng-container>
  <div class="content-container-directory">
    <div class="d-flex justify-content-between">
      <div>
        <div class="p-5">
          @for (category of categories; track category) {
            <button class="toggle" (click)="handleToggle(category)" [class.active]="filterSelection === category">{{category}}</button>
          }
        </div>
      </div>
    </div>
    <div>
      @if (showSpinner) {
        <div class="loading">
          <fa-icon [icon]="faCircleNotch" [animation]="'spin'"></fa-icon>
        </div>
      }
      <div class="table-wrapper">
        @if (filteredMembers && filteredMembers.length > 0) {
          <table class="ms-5 directory striped">
            <thead>
              <tr>
                <th class="imgCol"></th>
                <th class="nameCol">Name</th>
                <th class="roleCol">Role</th>
                <th class="branchCol">Branch</th>
                <th class="officeFloorCol">Office Floor</th>
                <!--<th class="directionBtnCol"></th>-->
              </tr>
            </thead>
            <tbody>
              @for (member of filteredMembers; track member) {
                <tr>
                  <td class="imgCol">
                    <div class="valign-wrapper">
                      <img class="profile-pic" [src]="member.imageUrl || member.thumbnailUrl" />
                    </div>
                  </td>
                  <td class="nameCol" [innerHTML]="(member.name || member.reportingName)"></td>
                  <td class="roleCol">{{member.role || member.title}}</td>
                  <td class="branchCol">{{member.branch}}</td>
                  <td class="officeFloorCol">{{member.roomNumber || member.room || member.houseRoomNumber || member.senateRoomNumber}}</td>
                  <!--<td class="directionBtnCol">
                  <button class="directionToggle" (click)="getDirection(member, member.roomNumber || member.room || member.houseRoomNumber || member.senateRoomNumber, member.memberCode || member.committeeCode)">Get Directions</button>
                </td>-->
              </tr>
            }
          </tbody>
        </table>
      }
    </div>
  </div>
</div>
</ng-container>

